// src/pages/admin/dashboard/components/RecentProjectsTable.js
import React from "react";
import { Col, Card, Table, Badge } from "react-bootstrap";

const RecentProjectsTable = ({ recentProjects }) => {
  return (
    <Col lg={7}>
      <Card className="dashboard-table-card h-100">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5 className="chart-title">
              Recent Projects
            </h5>

            <Badge bg="danger">
              Live
            </Badge>
          </div>

          <div className="table-responsive recent-projects-scroll">
            <Table
              hover
              borderless
              className="dashboard-table align-middle"
            >
              <thead>
                <tr>
                  <th>Project</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Applications</th>
                </tr>
              </thead>

              <tbody>
                {recentProjects.map((project) => (
                  <tr key={project.id}>
                    <td>
                      {project.project_name}
                    </td>

                    <td>
                      {project.project_type}
                    </td>

                    <td>
                      <Badge
                        bg={
                          project.status === "Active"
                            ? "success"
                            : project.status === "Casting"
                            ? "warning"
                            : "secondary"
                        }
                      >
                        {project.status}
                      </Badge>
                    </td>

                    <td>
                      {project.applications}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default RecentProjectsTable;
